import { IDistributedTraceContext } from '@microsoft/applicationinsights-core-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import type { ITelemetryItem } from '@microsoft/applicationinsights-web';

export interface IProvideTracingContextId {
  tracingContextId: string;
}
export type ILog = {
  initialize(connectionString: string): void;
  info: (...args: any[]) => void;
};

export function redactToken(value: string | undefined): string | undefined {
  if (!value) return value;
  return value.replace(/([?&])arcgisToken=[^&]*/g, '$1arcgisToken=REDACTED');
}

function sanitizeUrlFields(data: Record<string, any> | undefined): void {
  if (!data) return;
  for (const key of Object.keys(data)) {
    if (typeof data[key] === 'string') {
      data[key] = redactToken(data[key]);
    }
  }
}

export function sanitizeTokensFromTelemetry(envelope: ITelemetryItem): boolean {
  sanitizeUrlFields(envelope.baseData);
  sanitizeUrlFields(envelope.data as Record<string, any> | undefined);
  return true;
}

let appInsights: ApplicationInsights | null;
let tracingContext: IDistributedTraceContext | undefined | null;

const log: ILog & IProvideTracingContextId = {
  // @ts-ignore
  info(args) {
  },
  initialize: function (connectionString: string | undefined): void {
    if(!connectionString) return;

    appInsights = new ApplicationInsights({ config: {
      connectionString
    } });
    appInsights.loadAppInsights();
    appInsights.addTelemetryInitializer(sanitizeTokensFromTelemetry);
    appInsights.trackPageView();
    tracingContext = appInsights.getTraceCtx()
  },
  get tracingContextId() {
    return tracingContext?.getTraceId() || '';
  }
};
export default log;
